import "./LoadingIndicator.css";

const LoadingIndicator = () => <div className="lds-dual-ring"></div>;

export default LoadingIndicator;
